// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__Pcbow","box":"style_box__e0Y3p","active":"style_active__xOgiD","title":"style_title__ehD0T","item":"style_item__pXAtj"};